import stringsToSymbols from "@/util/strings-to-symbols.mjs";

// Do not change the ordering!
export const ROLE_SYMBOLS = stringsToSymbols([
  "all",
  "top",
  "jungle",
  "mid",
  "adc",
  "support",
]);

export function mapRoleToSymbol(role) {
  if (typeof role === "symbol") return role;
  switch ((role || "").toLowerCase()) {
    case "top":
      return ROLE_SYMBOLS.top;
    case "jng":
    case "jungle":
      return ROLE_SYMBOLS.jungle;
    case "mid":
    case "middle":
      return ROLE_SYMBOLS.mid;
    case "adc":
    case "duo_carry":
    case "bot":
    case "bottom":
      return ROLE_SYMBOLS.adc;
    case "support":
    case "sup":
    case "duo_support":
    case "utility":
      return ROLE_SYMBOLS.support;
    case "all":
    case "":
      return ROLE_SYMBOLS.all;
    default:
      return null;
  }
}
